"use strict";

/* -------------------------------------------------------------------------

	PUNITED.products_category_list

	トップページのスクリプトを定義
	※jQuery必須
	Potential United inc.

------------------------------------------------------------------------- */
// グローバル名前空間定義
var PUNITED;
if (!PUNITED) PUNITED = {};
if (!PUNITED.products_category_list) PUNITED.products_category_list = {};

(function () {
  // グローバル名前空間オブジェクトをローカルオブジェクトに置き換え
  var ns = PUNITED.products_category_list;
  /* -----------------------------------------------------
  
  ----------------------------------------------------- */

  ns.handleAccordions = function () {
    if (!PUNITED.common.mediaQuery.matches) {
      return;
    }

    var accordions = document.querySelectorAll('.product_list_accordion');
    accordions.forEach(function (accordion) {
      accordion.open = false;
      accordion.classList.remove('--open');
      var icon = accordion.querySelector('.product_list_accordion_title__icon');
      icon.classList.remove('--open');
    });
  };

  ns.handleFilter = function () {
    var groups = document.querySelectorAll('.product_l2_category_form');
    groups.forEach(function (group) {
      var accordions = group.querySelectorAll('.product_list_accordion');
      var inputs = Array.from(group.querySelectorAll('.checkbox_box__list input'));
      inputs.forEach(function (input) {
        input.addEventListener('change', function (e) {
          var input = e.currentTarget;
          changeInput(input, inputs, accordions);
        });
        input.checked = false;
      });
      changeInput(inputs[0], inputs, accordions);
    });

    function changeInput(input, inputs, accordions) {
      var values = [];

      if (input.value === 'all') {
        input.checked = true;
      } else {
        values = inputs.reduce(function (values, input) {
          if (input.value === 'all' || !input.checked) {
            return values;
          }

          values.push(input.value);
          return values;
        }, []);

        if (values.length > 0) {
          input.checked = false;
        }
      }

      toggleArticle(values, inputs, accordions);
    }

    function toggleArticle(values, inputs, accordions) {
      if (values.length === 0) {
        inputs.forEach(function (input) {
          toggleInput(input, input.value === 'all');
        });
        accordions.forEach(function (article) {
          article.style.display = 'block';
        });
      } else {
        inputs.forEach(function (input) {
          toggleInput(input, values.includes(input.value));
        });
        accordions.forEach(function (article) {
          var show = values.some(function (value) {
            return article.id === value;
          });
          article.style.display = show ? 'block' : 'none';
        });
      }
    }

    function toggleInput(input, checked) {
      input.checked = checked;
    }
  };
})();

$(function () {
  PUNITED.utils.imgSlider();
  PUNITED.products_category_list.handleAccordions();
  PUNITED.products_category_list.handleFilter();
  PUNITED.useful.detailsAccordion('.product_list_accordion', '.product_list_accordion_title__icon');
  PUNITED.utils.anchorMenu();
});